import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModalConfirmacionBorrado = ({ modalConfirm, cerrarModalConfirmacion, cargando }) => {
    return (
        <Modal show={modalConfirm.show} onHide={cerrarModalConfirmacion} centered>
            <Modal.Header closeButton className="border-bottom-0 pb-0">
                <Modal.Title className="fs-1 fw-bold text-800">
                    {modalConfirm.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-3 text-700 fs--1">
                {modalConfirm.message}
            </Modal.Body>
            <Modal.Footer className="border-top-0 pt-0">
                <Button variant="secondary" size="sm" onClick={cerrarModalConfirmacion} disabled={cargando}>
                    Cancelar
                </Button>
                <Button 
                    variant={modalConfirm.variant || 'danger'} 
                    size="sm" 
                    onClick={modalConfirm.onConfirm}
                    disabled={cargando}
                >
                    {modalConfirm.confirmText || 'Confirmar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalConfirmacionBorrado;
